const init = () => {

  // Sticky nav for tour page
  if (document.getElementById('tour-summary')) {
    stickyNav();
  }


  // Tour Itinerary & Accomodation Tab/Accordion
  if (document.getElementById('tour-itinerary') || document.getElementById('tour-accommodation')) {
    tabControl();
    tabNext();

    let resizeTimer;
    $(window).on('resize', function (e) {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        tabControl();
      }, 250);
    });
  }

};

const stickyNav = () => {
  let tourSummaryNav = $('.tour-summary__nav').offset().top;
  let tourName = $('h1:first').html();

  $(window).scroll(function () {
    if ($(window).scrollTop() > tourSummaryNav) {
      $('.tour-summary__nav').addClass('sticky');
    } else {
      $('.tour-summary__nav').removeClass('sticky');
    }
  });

  // scroll to in page IDs
  $('a.js-smooth-scroll[href*="#"]').on('click', function (e) {
    e.preventDefault();

    // Post GTM tracking
    let holidayAnchorText = $(this).text();
    GTM.holidayAnchor(tourName, holidayAnchorText);

    // Do not account for sticky nav height in tour summary section
    let summaryNavHeight = 0;

    if ($(this).attr('href') != '#tour-summary') {
      summaryNavHeight = $('.tour-summary__nav').height() + 30;
    }

    $('html, body').animate({
      scrollTop: $($(this).attr('href')).offset().top - summaryNavHeight,
    }, 500, 'linear')
  });

  $('.tour-summary__nav-dropdown').change(function () {

    // Post GTM tracking
    let holidayDropdownText = $(this).find('option:selected').text();
    GTM.holidayAnchor(tourName, holidayDropdownText);

    // Do not account for sticky nav height in tour summary section
    let summaryNavHeight = 30;

    if ($(this).val() != '#tour-summary') {
      summaryNavHeight = $('.tour-summary__nav').height() + 50;
    }

    $('html, body').animate({
      scrollTop: $($(this).val()).offset().top - summaryNavHeight,
    }, 500, 'linear')

    $(this).val('Jump to section');
  });
};

const tabControl = () => {
  let tabs = $('.tabbed-content').find('.tabbed-content__tabs');
  if (tabs.is(':visible')) {
    tabs.find('a').on('click', function (e) {
      e.preventDefault();
      let target = $(this).attr('href'),
        tabs = $(this).parents('.tabbed-content__tabs'),
        buttons = tabs.find('a'),
        item = tabs.parents('.tabbed-content').find('.tabbed-content__item');
      buttons.removeClass('active');
      item.removeClass('active');
      $(this).toggleClass('active');
      $(target).toggleClass('active');

      // If top of screen is below start of accordion, return user to top of active accordion item
      let offset = $(target).closest('.section').offset().top;
      tabAnchor(offset);

      // Refresh image gallery on tab change so that image height can be calculated
      $(target).find('.slick-slider').slick('setPosition');
    });
  } else {
    $('.tabbed-content__item').on('click', function () {
      let container = $(this).parents('.tabbed-content'),
        currId = $(this).attr('id'),
        items = container.find('.tabbed-content__item');
      container.find('.tabbed-content__tabs a').removeClass('active');
      items.removeClass('active');
      $(this).toggleClass('active');
      container.find('.tabbed-content__tabs a[href$="#' + currId + '"]').addClass('active');

      // If top of screen is below start of accordion, return user to top of active accordion item
      let offset = $(this).offset().top;
      tabAnchor(offset);

      // Refresh image gallery on tab change so that image height can be calculated
      $(this).find('.slick-slider').slick('setPosition');
    });
  }
};

const tabAnchor = (offset) => {
  let summaryNavHeight = $('.tour-summary__nav').height() + 30;

  if ($(window).scrollTop() > offset) {
    $('html, body').animate({
      scrollTop: offset - summaryNavHeight,
    }, 0, 'linear')
  };
};

const tabNext = () => {
  let tabNextButton = $('.js-tab-next');

  // Detect 'next' button click
  tabNextButton.on('click', function (e) {
    e.preventDefault();

    // Find next tab and make this the active tab by clicking it
    let activeTab = $(this).closest('.tabbed-content').find('.tabbed-content__tab-list').find('a.active');
    let activeTabNext = activeTab.parent().next().find('a');
    activeTabNext.click();

  });
};

$(document).ready(function() {
  var title = $('#mobTitle');
  var dropdown = $('#collectionsDropdown');
  
  title.click(function() {
    title.hide();
    dropdown.addClass('visible');
  });
  
  $('#collectionsDropdown a').click(function() {
    dropdown.removeClass('visible');
    title.show();
  });
});

export {
  init
}